import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import IconExternalLink from "../../../../assets/images/svg/external-link.svg";
import { getVarsoUrl } from "../../common/helpers/helpers";
import { getOMIMData } from "../../state/selectors/Omim.selectors";
import { omimStringTransformer } from "./constants";
import ComponentPanel from "../atoms/ComponentPanel/ComponentPanel";

const OmimVariant = ({ data }) => {
  const buildURL = (id, number) => {
    const url = `https://omim.org/entry/${id}`;
    let hashtag = null;
    if (!number) {
      return url;
    }
    if (number.toString().length === 1) {
      hashtag = `#000${number}`;
    } else if (number.toString().length === 2) {
      hashtag = `#00${number}`;
    } else if (number.toString().length === 3) {
      hashtag = `#0${number}`;
    }
    if (hashtag) {
      return `${url}${hashtag}`;
    }
    return url;
  };
  const noDataAvailable = (
    <div className="well well-lg text-center">
      <span className="h4" data-testid="omim-variant-no-data">
        No data available
      </span>
    </div>
  );
  const content = data ? (
    <div className="varsome-inner-container" data-testid="omim-variant-data">
      {data[0].items.map((item, i) => (
        <div
          key={item.phenotype_name}
          data-testid="omim-variant-phenotype-name"
        >
          {i === 0 ? null : (
            <hr style={{ width: "98%", margin: "40px auto" }} />
          )}
          <div className="tw-flex tw-items-start tw-mb-1">
            <h4 className="tw-mb-0">{item.phenotype_name}</h4>
            {item && item?.omim_id ? (
              <a
                className="tw-text-xs"
                href={getVarsoUrl(buildURL(item?.omim_id, item?.number))}
                target="_blank"
              >
                <IconExternalLink className="tw-w-5 tw-h-5 tw-ml-1" />
              </a>
            ) : null}
          </div>

          {item?.mutations ? (
            <p
              className="tw-my-0 tw-text-xs"
              data-testid="omim-variant-mutations"
            >
              <b>Mutations:</b> {item.mutations}
            </p>
          ) : null}
          {item?.alternative_phenotype_names ? (
            <div
              className="tw-my-0 tw-text-xs tw-flex"
              data-testid="omim-variant-alternative-phenotypes"
            >
              <b>Alt Names:</b>
              <ul className="tw-pl-6">
                {item.alternative_phenotype_names.map((names) => (
                  <li key={names}>{names}</li>
                ))}
              </ul>
            </div>
          ) : null}

          <div
            className="tw-mt-2 tw-text-sm"
            data-testid="omim-variant-description"
          >
            {omimStringTransformer(item.description, item?.references)}
          </div>
        </div>
      ))}
    </div>
  ) : (
    noDataAvailable
  );
  return data ? (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title="OMIM &reg;"
          version={data?.[0].version}
          url={getVarsoUrl("https://omim.org/")}
          titleDetailsRight={
            <div
              className="varsome-right tw-mr-4"
              data-testid="omim-variant-faq"
            >
              <small>
                <a href="https://omim.org/help/faq" target="_blank">
                  OMIM FAQ
                </a>
              </small>
            </div>
          }
          content={content}
        />
      </div>
    </div>
  ) : null;
};

OmimVariant.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      version: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          mutations: PropTypes.string,
          number: PropTypes.number,
          omim_id: PropTypes.number,
          phenotype_name: PropTypes.string,
          alternative_phenotype_names: PropTypes.arrayOf(PropTypes.string),
          references: PropTypes.arrayOf(
            PropTypes.shape({
              pub_med_references: PropTypes.arrayOf(PropTypes.number),
              reference_number: PropTypes.number,
              title: PropTypes.string,
              source: PropTypes.string,
              authors: PropTypes.string,
            })
          ),
        })
      ),
    })
  ),
};

OmimVariant.defaultProps = {
  data: null,
};

const mapStateToProps = (state) => ({
  data: getOMIMData(state),
});

export default connect(mapStateToProps)(OmimVariant);
